/**
 * Adds increment/decrement buttons to quantity input fields
 * @param {jQuery} $container - jQuery object containing the quantity input
 * @param {string|number} step - Step value for increment/decrement
 */
function addIncDecQty($container, step) {
    const numericStep = Number(step);
    
    // Check if buttons already exist to avoid duplicates
    if ($container.siblings('.decrement-qty, .increment-qty').length > 0) {
        return;
    }
    
    $container.before(
        `<a href="#" class="decrement-qty" aria-label="Decrease quantity" role="button">-</a>`
    ).after(
        `<a href="#" class="increment-qty" aria-label="Increase quantity" role="button">+</a>`
    );
}

/**
 * Initialize quantity controls for newly added elements
 * Call this function after AJAX content is loaded
 * @param {jQuery|string} container - Container to search for new qty-box elements (optional)
 */
function initializeQtyControls(container) {
    const $searchArea = container ? $(container) : $(document);
    $searchArea.find('.qty-wrapper .qty-box').each(function() {
        addIncDecQty($(this), '1');
    });
}

/**
 * Increments the quantity value
 * @param {jQuery} $input - jQuery object of the quantity input
 * @param {number} step - Amount to increment by
 */
function incrementQty($input, step) {
    const currentVal = Number($input.val());
    $input.val(currentVal + step);
}

/**
 * Decrements the quantity value, preventing values below the step amount
 * @param {jQuery} $input - jQuery object of the quantity input
 * @param {number} step - Amount to decrement by
 */
function decrementQty($input, step) {
    const currentVal = Number($input.val());
    if (currentVal > step) {
        $input.val(currentVal - step);
    }
}

// Initialize quantity controls on page load
$(() => {
    initializeQtyControls();
    
    // Use event delegation for increment/decrement buttons
    // This will work for both existing and future dynamically added elements
    $(document).on('click', '.decrement-qty', function(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event bubbling
        
        // Try multiple ways to find the correct input
        let $input = $(this).siblings('.qty-box').first();
        
        // If not found as sibling, try looking in the same parent container
        if ($input.length === 0) {
            $input = $(this).closest('.qty-wrapper').find('.qty-box').first();
        }
        
        // If still not found, try looking in the immediate parent
        if ($input.length === 0) {
            $input = $(this).parent().find('.qty-box').first();
        }
        
        if ($input.length > 0) {
            decrementQty($input, 1);
        } else {
            console.warn('Could not find qty-box for decrement button');
        }
    });
    
    $(document).on('click', '.increment-qty', function(e) {
        e.preventDefault();
        e.stopPropagation(); // Prevent event bubbling
        
        // Try multiple ways to find the correct input
        let $input = $(this).siblings('.qty-box').first();
        
        // If not found as sibling, try looking in the same parent container
        if ($input.length === 0) {
            $input = $(this).closest('.qty-wrapper').find('.qty-box').first();
        }
        
        // If still not found, try looking in the immediate parent
        if ($input.length === 0) {
            $input = $(this).parent().find('.qty-box').first();
        }
        
        if ($input.length > 0) {
            incrementQty($input, 1);
        } else {
            console.warn('Could not find qty-box for increment button');
        }
    });
});

// // Add debounce function to limit API calls
// function debounce(func, wait) {
//   let timeout;
//   return function executedFunction(...args) {
//     const later = () => {
//       clearTimeout(timeout);
//       func(...args);
//     };
//     clearTimeout(timeout);
//     timeout = setTimeout(later, wait);
//   };
// }

// // Debounced AJAX function to update quantity
// const updateQuantityAjax = debounce(function(event, quantity) {
//   console.log('updateQuantityAjax called with quantity:', quantity);
//   updateCartAjaxCall(event);
// }, 500); // 500ms delay

// This will run after ANY successful AJAX call on your page
$(document).ajaxSuccess(function(event, xhr, settings) {
    // Check if this is a product-search AJAX call
    if (settings.url && settings.url.includes('/product-search/product-search-ajax/')) {
        // Re-initialize quantity controls after any product search AJAX call
        initializeQtyControls();
    }
});

  